import { ErrorMessage } from "@hookform/error-message";
import { useState } from "react";
import CurrencyInput from "react-currency-input-field";
import { Controller, useFormContext } from "react-hook-form";
import ErrorLabel from "./errorLabel.tsx";

type Props = {
  name: string;
  label?: string;
  prefix?: string;
  min?: number;
  max?: number;
  step?: number;
  decimalsLimit?: number;
};

export default function NumberInput({
  name,
  label,
  prefix,
  min,
  max,
  step,
  decimalsLimit = 2,
}: Props) {
  const { getValues } = useFormContext();
  const [formattedValue, setFormattedValue] = useState<string | undefined>(
    getValues(name),
  );

  const inputElement = (
    <>
      <div className="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-sky-600 sm:max-w-md">
        {prefix && (
          <span className="flex select-none items-center pl-3 text-gray-500 sm:text-sm">
            {prefix}
          </span>
        )}
        <Controller
          name={name}
          render={({ field }) => (
            <CurrencyInput
              name={name}
              className="block flex-1 border-0 bg-transparent py-1.5 pl-3 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm sm:leading-6"
              min={min}
              max={max}
              step={step}
              decimalsLimit={decimalsLimit}
              allowDecimals={true}
              value={formattedValue}
              onValueChange={(_, __, values) => {
                setFormattedValue(values?.value);
                field.onChange(values?.float);
              }}
            />
          )}
        />
      </div>
      <ErrorMessage
        name={name}
        render={({ message }) => (
          <ErrorLabel
            message={
              message.includes("null") ? "This field is required" : message
            }
          />
        )}
      />
    </>
  );

  return label != null ? (
    <div className="sm:col-span-4">
      <label
        htmlFor="constructionValue"
        className="block text-sm font-medium leading-6 text-gray-900"
      >
        {label}
      </label>
      <div className="mt-1">{inputElement}</div>
    </div>
  ) : (
    inputElement
  );
}
